import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators';

import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import '../google/pdq-google-auth';
import '../google/pdq-google-login-button';
import '../google/pdq-google-file-request';
import './PDQCodeHtml';
import { row } from 'src/styles';

@customElement('pdq-tutorial-google-auth')
export class PDQTutorialGoogleAuth extends LitElement {

  static styles = [row]

  render() {
    const code = `<pdq-google-auth
        clientId="975663363483-m6gmi17vsdqvn38cu4dr48ca817lfdoo.apps.googleusercontent.com"
        scopes="https://www.googleapis.com/auth/drive"
        showIdentity="true"
      ></pdq-google-auth>`;
    const code1 = `<pdq-google-login-button show-identity="true"></pdq-google-login-button>`

    const code2 = `<pdq-google-api><script slot="services" type="application/json">
[{"service": "drive", "version": "v3"}]
</script></pdq-google-api>`

    const code3 = `
<pdq-google-file-request fileId="1sIAxv3w5XFbxG6-FNu2uh-GH218AUsEl" table="response"></pdq-google-file-request>
<pdq-perspective-viewer table="response"></pdq-perspective-viewer>
<pdq-dump table="response"></pdq-dump>
`

    const allCode = `${code}
${code1}
${code2}
${code3}`
    return html`
      <cds-tile>
        <h2>Google Auth</h2>
               
        <p>To add google auth to the page, simply add the 
          <cds-tag>pdq-google-auth</cds-tag> to the page. Get you client id 
          from the OAuth 2.0 Client IDs section of
          <a href="https://console.cloud.google.com/apis/credentials">google cloud console.</a>
          also add your domain to the "Authorised JavaScript origins" section.
        </p>
        <pdq-code-html code="${code}"></pdq-code-html>

        ${unsafeHTML(code)}
        <p>This will dynamically load the auth libraries from google</p>

        <p>show a login button using <cds-tag>pdq-google-login-button</cds-tag></p>
        
        <pdq-code-html code="${code1}"></pdq-code-html>
        ${unsafeHTML(code1)}
        
        <p>To add google apis to the page use the <cds-tag>pdq-google-api</cds-tag>
        tag, and define what apis you want with the services collection specifying the 
        service name and version. <a href="https://developers.google.com/apis-explorer">Find apis here</a></p>

        <pdq-code-html code="${code2}"></pdq-code-html>
        ${unsafeHTML(code2)}

        <p>now we are setup with google auth and goole api, lets get a file and render it...</p>
        <pdq-code-html code="${code3}"></pdq-code-html>
        ${unsafeHTML(code3)}
        
        <hr>
        <p>Cheetsheet</p>
        <pdq-code-html code="${allCode}"></pdq-code-html>
      </cds-tile>
    `;

  }
}

